import TabPanel from "@mui/lab/TabPanel";
import { Grid, Button } from "@mui/material";
import SelectInput from "../../ingredients/SelectInput";
import { DataGrid } from "@mui/x-data-grid";

/**
 * @component Table Overview Component
 * this component displays the Table where it shows:
 * - the code
 * - technofunctionality
 * - ingredient
 * - source category
 * - sector
 * - product platform
 *
 * @param {function} t
 * @param {object} ingredientParams
 * @param {function} getParams
 * @param {function} handleParamsReset
 * @param {object} technofunctionalityParams
 * @param {function} handleParamsSubmit
 * @param {array} ingredients
 * @param {boolean} loading
 * @param {array} columns
 * @param {number} pageSize
 * @param {number} currentPage
 * @param {function} checkAccessLimit
 * @param {function} openDrawer
 * @returns {JSX.Element} Table Overview Component
 */
export default function TableOverview({ t, ingredientParams, getParams, handleParamsReset, technofunctionalityParams, handleParamsSubmit, ingredients, loading, columns, pageSize, currentPage, checkAccessLimit, openDrawer }) {
  return (
    <TabPanel value="2">
      {/* <HeadingTitle text={"Ingredients"} /> */}
      <Grid
        container
        spacing={2}
        columns={16}
        style={{ marginBottom: "30px" }}
      >
        {ingredientParams &&
          ingredientParams.map((param, index) => (
            <Grid item xs={3} key={index}>
              <SelectInput
                label={param}
                getParams={getParams}
                onReset={handleParamsReset}
                initialValue={
                  param === "Technofunctionality"
                    ? technofunctionalityParams
                    : []
                }
                technofunctionality={technofunctionalityParams || []}
              />
            </Grid>
          ))}

        <Grid item xs={4} justifyContent="space-between">
          <Button
            variant="contained"
            color="success"
            size="medium"
            onClick={handleParamsSubmit}
          >
            {t("dashboard.ingredientSelection.applyBtnText")}
          </Button>

          <Button
            variant="outlined"
            color="success"
            size="medium"
            style={{ marginLeft: 15 }}
            onClick={handleParamsReset}
          >
            {t("dashboard.ingredientSelection.resetBtnText")}
          </Button>
        </Grid>
      </Grid>
      <DataGrid
        autoHeight
        getRowHeight={() => ""}
        rows={ingredients?.ingredientsData || []}
        loading={loading}
        rowCount={ingredients?.total || 0}
        columns={columns}
        pagination
        pageSize={pageSize}
        pageSizeOptions={[10, 15, 20, 25, 50, 75, 100]}
        paginationMode="server"
        paginationModel={{ page: currentPage, pageSize: pageSize }}
        onPaginationModelChange={(model) => {
          checkAccessLimit(model.page, model.pageSize);
        }}
        initialState={{
          pagination: {
            paginationModel: {
              page: 0,
              pageSize: pageSize,
            },
          },
        }}
        onRowClick={(params) => {
          openDrawer(params.row);
        }}
      />
      {/* <DataGrid
        autoHeight
        getRowHeight={() => ""}
        rows={ingredients?.ingredientsData || []}
        loading={loading}
        rowCount={ingredients?.total || 0}
        columns={columns}
        pagination
        pageSize={pageSize}
        pageSizeOptions={[10, 15, 20, 25, 50, 75, 100]}
        paginationMode="server"
        paginationModel={{ page: currentPage, pageSize: pageSize }}
        onPaginationModelChange={(model) => {
          checkAccessLimit(model.page, model.pageSize);
        }}
        initialState={{
          pagination: {
            paginationModel: {
              page: 0,
              pageSize: pageSize,
            },
          },
        }}
        onRowClick={(params) => {
          openDrawer(params.row);
        }}
      /> */}
    </TabPanel>
  );
}